module.exports = __webpack_public_path__ + "img/button-hour.fed7304e.svg";